import { cx, css } from '@linaria/core';
import { flex, theming } from 'styles/utils';
import { textRegularLight } from 'styles/typography';
export const wrapper = "omponents__EntityCard__EntityPopover_styles_ts-wrapper-wfg44j4";
export const option = cx("omponents__EntityCard__EntityPopover_styles_ts-option-o7nujzu", flex.init, flex.alignItems.center, textRegularLight);
export const danger = cx("omponents__EntityCard__EntityPopover_styles_ts-danger-d1j392o3");

require("./EntityPopover.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./EntityPopover.styles.ts");